import { ApprovalStatus } from 'rev-shared/media/MediaConstants';

export class ApprovalStatusInfo {
	private status: string;

	constructor(approvalStatus: string) {
		this.status = approvalStatus;
	}

	public get isRequireApprovalStage(): boolean {
		return this.status
			=== ApprovalStatus.REQUIRES_APPROVAL;
	}

	public get isPendingApprovalStage(): boolean {
		return this.status
			=== ApprovalStatus.PENDING_APPROVAL;
	}

	public get isApprovedApprovalStage(): boolean {
		return this.status
			=== ApprovalStatus.APPROVED;
	}

	public get isRejectedApprovalStage(): boolean {
		return this.status
			=== ApprovalStatus.REJECTED;
	}
}
